import { createRoute } from '@tanstack/react-router';
import { IconMail } from '@tabler/icons-react';
import type { Zone } from '@hana/shell';
import { registerBoxFixtures } from './data';
import { BoxPage } from './mail/BoxPage';
import { AskHanaPage } from './askhana/AskHanaPage';

export { AskHanaPage };

// Vùng HANA Box (/box): hộp thư chung nhóm BKG (luồng I, docs/streams/I.md). Khung + dữ liệu mẫu; màn thư Mint-Box ở mail/BoxPage (I-02a).

export const zone: Zone = {
  key: 'box',
  name: 'HANA Box',
  fixtures: registerBoxFixtures,
  top: [{ key: 'home', label: 'Thư', to: '/box', icon: IconMail }],
  nav: [],
  routes: (parent) => [
    createRoute({ getParentRoute: () => parent, path: '/', component: BoxPage }),
    // Ask HANA (I-05): màn toàn trang, gắn tạm ở /box/ask để đo; A lắp vào shell (nút cú ở mọi vùng) theo issue luong-a.
    createRoute({ getParentRoute: () => parent, path: '/ask', component: AskHanaPage }),
  ],
};
